// @flow

import * as React from 'react';
import PropTypes from 'prop-types';

import Popover from '@mui/material/Popover';

const Overlay = ({
  visible = false,
  onHide,
  children,
  target = null,
  ...restProps
}) => (
  <Popover
    open={visible}
    anchorEl={target}
    onClose={onHide}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    {...restProps}
  >
    {children}
  </Popover>
);

Overlay.propTypes = {
  onHide: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool,
  target: PropTypes.object
};

export default Overlay;